import { connect, ConnectedProps } from "react-redux";

import { UnavailableDateModal } from "./component";
import {
  getActivityDetailsProperties,
  getExperiencesNoAvailability,
  getExperiencesSearchLocation,
  getExperiencesShopBookableItems,
  getExperiencesShopOptionsCallState,
  getExperiencesShopSimilar,
  getExperienceId,
  getNextAvailableDate,
  getNextAvailableDateCallState,
  getSelectedDate,
  getTravelerCounts,
} from "../../reducer/selectors";
import { IStoreState } from "../../../../reducers/types";
import { getFromDate, getUntilDate } from "../../../search/reducer";
import { actions } from "../../actions";
import {
  getSelectedAccount,
  getSelectedAccountReferenceIdIfRedemptionEnabled,
} from "../../../rewards/reducer";

const mapStateToProps = (state: IStoreState) => {
  const shopSimilar = getExperiencesShopSimilar(state);
  return {
    noAvailability: getExperiencesNoAvailability(state),
    shopOptionsCallState: getExperiencesShopOptionsCallState(state),
    selectedDate: getSelectedDate(state),
    fromDate: getFromDate(state),
    untilDate: getUntilDate(state),
    locationLabel: getExperiencesSearchLocation(state),
    similarExperiences: shopSimilar?.similarExperiences,
    selectedRewardsAccount: getSelectedAccount(state),
    rewardsKey: getSelectedAccountReferenceIdIfRedemptionEnabled(state),
    bookableItems: getExperiencesShopBookableItems(state),
    experienceId: getExperienceId(state),
    travelerCounts: getTravelerCounts(state),
    pricingOpaque: state.experiencesShop.experiencesShopDetails?.pricingOpaque,
    bookableItemDates: state.experiencesShop.bookableItemDates ?? [],
    nextAvailableDate: getNextAvailableDate(state),
    nextAvailableDateCallState: getNextAvailableDateCallState(state),
    activityDetailsProperties: getActivityDetailsProperties(state),
  };
};

const mapDispatchToProps = {
  findNextAvailableDate: actions.findNextAvailableDate,
  setSelectedDate: actions.setSelectedDate,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type UnavailableDateModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedUnavailableDateModal = connector(UnavailableDateModal);
